import { useMemo, type MouseEvent } from "react";
import { renderMarkdown } from "@/utils/markdown";

interface SchoolFitSummaryProps {
  markdown?: string | null;
  fallback: string;
  lines?: 2 | 4;
  className?: string;
}

export function SchoolFitSummary({
  markdown,
  fallback,
  lines = 4,
  className = "",
}: SchoolFitSummaryProps) {
  const html = useMemo(() => renderMarkdown(markdown || fallback), [fallback, markdown]);

  function preserveLinkClick(event: MouseEvent<HTMLDivElement>) {
    if ((event.target as HTMLElement).closest("a, button")) event.stopPropagation();
  }

  return (
    <div
      className={`school-fit-summary prose prose-sm max-w-none overflow-hidden text-forest-soft prose-headings:my-1 prose-headings:font-display prose-headings:text-[11px] prose-headings:font-extrabold prose-p:my-0 prose-ul:my-1 prose-ol:my-1 prose-li:my-0 prose-strong:text-forest prose-a:text-primary-text ${lines === 2 ? "line-clamp-2" : "line-clamp-4"} ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
      onClick={preserveLinkClick}
    />
  );
}
